import React, { Component } from 'react';
import { authentication } from '../services/Authentication';
import { withRouter } from "react-router-dom";
import { config } from '../Constants';
import helpers from '../Function';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";
import { ExcelRenderer } from 'react-excel-renderer';
import moment from 'moment';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { Button, Upload } from "antd";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class PaymentAmount extends Component {
    fileImageObj = [];
    fileArray = [];

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        this.state = {
            PROJECTID: project_id,
            jwt: jwt,
            rows: [],
            errorMessage: null,
            user_permission: user_permission,
            userid: user_id,
            create_by: name,
            create_by_id: user_id,
            miss_suc: helpers.getUserType(user_type, "suc"),
            miss_su: helpers.getUserType(user_type, "su"),
            src_project: "",
            src_house_no: "",
            src_plot: "",
            src_payment_type: "",
            src_contract_number: "",
            add_id: "",
            add_contract_number: "",
            add_sales_price: "",
            add_deposit: "",
            add_balance: "",
            val_payment_type: "waiting",
            add_payment_type: "",
            val_project: "",
            add_project: "",
            add_house_no: "",
            val_house_no: "",
            add_plot: "",
            add_paymentdowntotal: 0,
            img: '',
            add_paymentdown: "",
            add_transfer_price: "",
            add_transfer_date: "",
            val_plot: "",
            add_active_status: "",
            active: 1,
            period: [],
            period_hp: [],
            period_check: [],
            plot: [],
            residences: [],
            project_home: [],
            project_homes: [{ value: '', display: 'เลือกโครงการ' }],
            project_type_pages: [],
            EditLineIsOpen: false,
            ImgIsOpen: false,
            importIsOpen: false,
            pages: [],
            dataimport: [],
            page: 0,
            rowsPerPage: 10,
            file: null,
            spinner: true,
            IsVerify: false,
            add_address: '',
        }

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.openAdd = this.openAdd.bind(this);
        this.submitAdd = this.submitAdd.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.closeImg = this.closeImg.bind(this);
        this.closeAdd = this.closeAdd.bind(this);
        this.closeSrc = this.closeSrc.bind(this);
        this.closeModelUpdate = this.closeModelUpdate.bind(this);
        this.closeModelPeriodUpdate = this.closeModelPeriodUpdate.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.change = this.change.bind(this);
        this.openView = this.openView.bind(this);
        this.openEdit = this.openEdit.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.openDelete = this.openDelete.bind(this);
        this.openImg = this.openImg.bind(this);
        this.submitDelete = this.submitDelete.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.openEditLine = this.openEditLine.bind(this)
        this.closeEditLine = this.closeEditLine.bind(this)
        this.AddEditLine = this.AddEditLine.bind(this)
        this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this)
        this.changeName = this.changeName.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onTagsChange = this.onTagsChange.bind(this)
        this.changeProjectType = this.changeProjectType.bind(this);

        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)

        this.openImport = this.openImport.bind(this);
        this.closeImport = this.closeImport.bind(this);
        this.submitImport = this.submitImport.bind(this);
        this.submitVerify = this.submitVerify.bind(this);

        this.project_home()
        //this.project_homes()
        this.dataTable();
        this.project_type()
    }

    project_type() {
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/project_types', requestOptions)
            .then(res => res.json())
            .then(data => {
                const sortedActivities = data.data.sort(function (a, b) {
                    return new Date(b.num) - new Date(a.num);
                });

                var found = sortedActivities.filter(function (item) { return item.active; });
                var found2 = found.filter(function (item) { return !item.delete; });

                var FromApi = found2.map(datas => {
                    return { value: datas.id, display: datas.name_th }
                });

                this.setState({
                    project_type_pages: [{ value: '', display: 'เลือกประเภทโครงการ' }].concat(FromApi)
                });

            });
    }

    openImport() {
        this.setState({
            importIsOpen: true,
            rows: [],
            errorMessage: null,
            IsVerify: false
        });
    }

    closeImport() {
        this.setState({
            importIsOpen: false,
        });
    }

    submitImport() {
        if (this.state.rows.length < 1) {
            alert("ไม่มีข้อมูลการ import")
            return
        }

        if (!this.state.IsVerify) {
            alert("กรุณาตรวจสอบข้อมูล")
            return
        }

        this.setState({
            importIsOpen: false,
            spinner: true
        });

        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                import_data: this.state.rows,
                createby: this.state.create_by,
                createby_id: this.state.create_by_id

            })
        };

        fetch(config.url.API_URL + '/import_payment', requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    //importIsOpen: false,
                    updateIsOpen: true,
                    spinner: false
                });
            });
    }

    project_home(project_types_id) {
        var body = ``
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        if (this.state.PROJECTID) {
            body = `?projecthomeid=${this.state.PROJECTID}`
            fetch(config.url.API_URL + '/project_homes/' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sortData = data.data.sort(function (a, b) {
                        return a.num - b.num;
                    });

                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });

                    var FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });

                    this.setState({
                        project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                    });
                });
        } else if (project_types_id) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            var body = `?project_type_id=${project_types_id}`
            fetch(config.url.API_URL + '/project_homesSrc/' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sortData = data.data.sort(function (a, b) {
                        return b.num - a.num;
                    });
                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });

                    var FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });

                    this.setState({
                        project_homes: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                    });

                });

        } else {
            fetch(config.url.API_URL + '/project_homes/', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sortData = data.data.sort(function (a, b) {
                        return a.num - b.num;
                    });

                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });

                    var FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });

                    this.setState({
                        project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                    });
                });
        }

    }

    dataTable() {

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        if (this.state.PROJECTID) {
            this.state.src_project = this.state.PROJECTID
        }

        fetch(config.url.API_URL + '/payment/?projecthomeid=' + (this.state.src_project ? this.state.src_project : '')
            + '&houseno=' + (this.state.src_house_no ? this.state.src_house_no : '')
            + '&plot=' + (this.state.src_plot ? this.state.src_plot : '')
            + '&contractno=' + (this.state.src_contract_number ? this.state.src_contract_number : '')
            + '&paymenttype=' + (this.state.src_payment_type ? this.state.src_payment_type : '')
            + '&project_type_id=' + (this.state.add_project_type ? this.state.add_project_type : '')
            , requestOptions)
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data.data) && data.data.length) {
                    var FromApi = data.data.map(datas => {
                        var address = '';
                        var project_homes_name = '';
                        var customer_name = '';
                        var customer_tell = '';
                        if (datas.project_homes.length) {
                            project_homes_name = datas.project_homes[0].name_th;
                            address = (datas.project_homes[0].moo && "ม. " + datas.project_homes[0].moo)
                                + (datas.project_homes[0].soi && " ซ. " + datas.project_homes[0].soi)
                                + (datas.project_homes[0].road && " ถ. " + datas.project_homes[0].road)
                                + (datas.project_homes[0].sub_district && " ต./แขวง " + datas.project_homes[0].sub_district)
                                + (datas.project_homes[0].district && " อ./เขต " + datas.project_homes[0].district)
                                + (datas.project_homes[0].province && " จ. " + datas.project_homes[0].province);
                        }

                        if (datas.residences.customer.length) {
                            customer_name = datas.residences.customer[0].customer_name
                            customer_tell = datas.residences.customer[0].customer_tell.length > 0 ? datas.residences.customer[0].customer_tell[0].tell : ""
                        }

                        return {
                            id: datas._id,
                            project_name: project_homes_name,
                            contract_number: datas.contract_number,
                            payment_type: helpers.paymentType(datas.payment_type),
                            address: address,
                            period: datas.period,
                            plot: datas.residences.plot == '' ? "-" : datas.residences.plot,
                            house_no: datas.residences.house_no,
                            customer_name: customer_name,
                            customer_tell: customer_tell,
                            add_address: datas.address,
                            updateby: datas.updateby != undefined ? datas.updateby : datas.createby,
                            updated: datas.updated != undefined ? `${moment(datas.updated).format("DD/MM/YYYY HH:mm น.")}` : `${moment(datas.created).format("DD/MM/YYYY HH:mm น.")}`,
                        }
                    });
                    console.log(FromApi)
                    this.setState({
                        spinner: false,
                        pages: [].concat(FromApi),
                        srcIsOpen: false,
                        dataimport: [].concat(data.dataimport)
                    });

                } else {
                    this.setState({
                        pages: [],
                        dataimport: []
                    });
                }
            });
    }

    openView(e) {
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/payment/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(dataMain => {
                var datas = dataMain.data[0];
                
                this.setState({
                    add_id: datas.id,
                    add_project: (datas.project_homes[0] === undefined ? "" : datas.project_homes[0].name_th),
                    add_house_no: (datas.residences[0] === undefined ? "" : datas.residences[0].house_no),
                    add_plot: (datas.residences[0] === undefined ? "" : datas.residences[0].plot),
                    add_contract_number: datas.contract_number,
                    add_payment_type: helpers.paymentType(datas.payment_type),
                    val_payment_type: datas.payment_type,
                    add_active_status: helpers.getActiveStatus(datas.active_status + ""),
                    period: datas.period,
                    add_sales_price: datas.sale_price,
                    add_deposit: datas.deposit,
                    add_balance: datas.balance,
                    add_img: datas.imgqr,
                    add_paymentdown: datas.payment_down,
                    add_paymentdowntotal: datas.payment_down_total,
                    add_transfer_price: datas.transfer_price,
                    add_transfer_date: moment(datas.transfer_date).format("DD/MM/YYYY"),
                    add_address: datas.address == undefined ? "" : datas.address
                });

                this.setState({
                    addIsOpen: true,
                    methodOpen: 'view'
                });
            });
    }

    async openEdit(e) {

        this.setState({
            add_paymentdown: "",
            add_paymentdowntotal: "",
            period_check: []
        });

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/payment/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(async dataMain => {
                var datas = dataMain.data[0];
                
                this.setState({
                    add_id: datas._id,
                    add_project: (datas.project_homes[0] === undefined ? "" : datas.project_homes[0].name_th),
                    val_project: datas.project_home_id,
                    add_house_no: (datas.residences[0] === undefined ? "" : datas.residences[0].house_no),
                    add_plot: (datas.residences[0] === undefined ? "" : datas.residences[0].plot),
                    val_plot: datas.residence_id,
                    add_contract_number: datas.contract_number,
                    add_payment_type: '',
                    val_payment_type: datas.payment_type,
                    active: datas.active_status,
                    period: datas.period,
                    img: datas.img,
                    add_sales_price: datas.sale_price,
                    add_deposit: datas.deposit,
                    add_balance: datas.balance,
                    add_paymentdown: datas.payment_down,
                    add_paymentdowntotal: datas.payment_down_total,
                    add_transfer_price: datas.transfer_price,
                    add_transfer_date: new Date(datas.transfer_date),
                    add_address: datas.address == undefined ? "" : datas.address
                });

                if (this.state.val_project) {
                    const requestOptions = {
                        method: 'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': this.state.jwt,
                        },
                    };

                    fetch(config.url.API_URL + '/residences/?projecthomeid=' + this.state.val_project, requestOptions)
                        .then(res => res.json())
                        .then(async data => {
                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                            //alert(data.status);
                            var FromApi = await data.data.map(datas => {
                                return datas.house_no
                            });

                            this.setState({
                                residences: FromApi
                            });

                            if (this.state.add_house_no) {
                                const requestOptions = {
                                    method: 'GET',
                                    headers: {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json',
                                        'Authorization': this.state.jwt,
                                    },
                                };

                                fetch(config.url.API_URL + '/residences/?projecthomeid=' + this.state.val_project
                                    + '&houseno=' + this.state.add_house_no
                                    , requestOptions)
                                    .then(res => res.json())
                                    .then(data => {
                                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                                        //alert(data.status);
                                        var FromApi = data.data.map(datas => {
                                            return { value: datas.id, display: (datas.plot ? datas.plot : "ไม่ระบุแปลง") }
                                        });

                                        this.setState({
                                            plot: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                                        });

                                    });
                            }
                        });
                }

                this.setState({
                    addIsOpen: true,
                    methodOpen: 'edit'
                });
            });
    }

    openImg(e) {
        this.setState({
            ImgIsOpen: true,
            img: e.currentTarget.attributes["data-id"].value
        });
    }

    async openEditAgain(id) {

        this.setState({
            period_check: []
        });

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/payment/' + id, requestOptions)
            .then(res => res.json())
            .then(async dataMain => {
                var datas = dataMain.data[0];
                
                this.setState({
                    add_id: datas._id,
                    add_project: (datas.project_homes[0] === undefined ? "" : datas.project_homes[0].name_th),
                    val_project: datas.project_home_id,
                    add_house_no: (datas.residences[0] === undefined ? "" : datas.residences[0].house_no),
                    add_plot: (datas.residences[0] === undefined ? "" : datas.residences[0].plot),
                    val_plot: datas.residence_id,
                    add_contract_number: this.state.add_contract_number != '' ? this.state.add_contract_number : datas.contract_number,
                    add_payment_type: '',
                    val_payment_type: datas.payment_type,
                    active: datas.active_status,
                    period: datas.period,
                    img: datas.img,
                    add_sales_price: datas.sale_price,
                    add_deposit: datas.deposit,
                    add_balance: datas.balance,
                    add_paymentdown: datas.payment_down,
                    add_paymentdowntotal: datas.payment_down_total,
                    add_transfer_price: datas.transfer_price,
                    add_transfer_date: new Date(datas.transfer_date),
                });

                if (this.state.val_project) {
                    const requestOptions = {
                        method: 'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': this.state.jwt,
                        },
                    };

                    fetch(config.url.API_URL + '/residences/?projecthomeid=' + this.state.val_project, requestOptions)
                        .then(res => res.json())
                        .then(async data => {
                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                            //alert(data.status);
                            var FromApi = await data.data.map(datas => {
                                return { value: datas.house_no, display: datas.house_no }
                            });

                            this.setState({
                                residences: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                            });

                            if (this.state.add_house_no) {
                                const requestOptions = {
                                    method: 'GET',
                                    headers: {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json',
                                        'Authorization': this.state.jwt,
                                    },
                                };

                                fetch(config.url.API_URL + '/residences/?projecthomeid=' + this.state.val_project
                                    + '&houseno=' + this.state.add_house_no
                                    , requestOptions)
                                    .then(res => res.json())
                                    .then(data => {
                                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                                        //alert(data.status);
                                        var FromApi = data.data.map(datas => {
                                            return { value: datas.id, display: (datas.plot ? datas.plot : "ไม่ระบุแปลง") }
                                        });

                                        this.setState({
                                            plot: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                                        });

                                    });
                            }
                        });
                }

                this.setState({
                    addIsOpen: true,
                    methodOpen: 'edit'
                });
            });
    }

    submitEdit(e) {

        const formData = new FormData();
        formData.append('project_home_id', this.state.val_project);
        formData.append('contract_number', this.state.add_contract_number);
        formData.append('payment_type', this.state.val_payment_type);
        formData.append('sale_price', this.state.add_sales_price);
        formData.append('payment_down', this.state.add_paymentdown);
        formData.append('payment_down_total', this.state.add_paymentdowntotal);
        formData.append('transfer_price', this.state.add_transfer_price);
        formData.append('transfer_date', this.state.add_transfer_date);
        formData.append('address', this.state.add_address == null || this.state.add_address == '' ? "" : this.state.add_address);
        formData.append('deposit', this.state.add_deposit);
        formData.append('balance', this.state.add_balance);
        formData.append('residence_id', this.state.val_plot);
        formData.append('active_status', this.state.active ? 1 : 0);
        formData.append('createby', this.state.create_by);
        formData.append('createby_id', this.state.create_by_id);
        formData.append('myImage', this.state.file);
        formData.append('period', JSON.stringify(this.state.period));


        const requestOptions = {
            method: 'PUT',
            headers: {
                'Authorization': this.state.jwt,
            },
            body: formData,
        };

        fetch(config.url.API_URL + '/payment/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    updateIsOpen: true,
                    addIsOpen: false
                });
            });
    }

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    openEditLine(e) {
        console.log(this.state.add_id)
        const result = this.state.period.filter((period) => {
            return period._id == e.currentTarget.attributes["data-id"].value
        })
        console.log(result)
        
        this.setState({
            add_period_status: "",
            EditLineIsOpen: true,
            edit_line_id: e.currentTarget.attributes["data-id"].value,
            period_no: `งวดที่ ${result[0].no}`,
            add_detail: result[0].detail,
            add_payment_date: new Date(result[0].payment_day),
            add_amount: result[0].amount
        });
    }

    closeEditLine() {
        this.setState({
            EditLineIsOpen: false
        });
    }

    uploadMultipleFiles(e) {
        this.fileImageObj.push(e.target.files)
        for (var i = 0; i < this.fileImageObj[0].length; i++) {
            this.fileArray.push(URL.createObjectURL(this.fileImageObj[0][i]))
        }
        
        this.setState({
            file: this.fileArray,
            imgCollection: e.target.files
        })
    }

    AddEditLine() {
        console.log("ADD")
        // const formData = new FormData();
        // formData.append('id', this.state.add_id);
        // formData.append('period_status', this.state.add_period_status);
        // formData.append('period_id', this.state.edit_line_id);
        // for (const key of Object.keys(this.state.imgCollection)) {
        //     formData.append('myImage', this.state.imgCollection[key])
        // }

        if (!this.state.add_period_status) {
            alert("ไม่พบข้อมูลสถานะ")
            return;
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                id: this.state.add_id,
                period_status: this.state.add_period_status,
                period_id: this.state.edit_line_id,
                payment_day: this.state.add_payment_date,
                amount: this.state.add_amount,
                detail: this.state.add_detail
            })
        };

        fetch(config.url.API_URL + '/paymentperiod', requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    updatePeriodIsOpen: true,
                    file: null
                });
            });
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        console.log(e.target.value)
        if (e.target.name == "val_project") {

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };

            fetch(config.url.API_URL + '/residences/?projecthomeid=' + e.target.value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    var FromApi = data.data.map(datas => {
                        return datas.house_no
                    });

                    this.setState({
                        residences: FromApi
                    });

                });
        } else if (e.target.name == "add_house_no") {

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };

            fetch(config.url.API_URL + '/residences/?projecthomeid=' + this.state.val_project
                + '&houseno=' + e.target.value
                , requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    var FromApi = data.data.map(datas => {
                        return { value: datas.id, display: (datas.plot ? datas.plot : "ไม่ระบุแปลง") }
                    });

                    this.setState({
                        plot: FromApi,
                        val_plot: FromApi[0].value
                    });

                });
        }

    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_project: '',
            val_project: '',
            add_house_no: '',
            val_plot: '',
            add_contract_number: '',
            add_sales_price: '',
            add_deposit: '',
            add_balance: '',
            add_payment_type: '',
            val_payment_type: 'waiting',
            add_paymentdown: '',
            add_paymentdowntotal: '',
            add_transfer_price: '',
            add_transfer_date: '',
            add_address: '',
            active: 1,
            period: [],
            plot: [],
            residences: [],
            active: true
        });

    }

    closeAdd() {
        this.setState({
            add_project: '',
            val_project: '',
            add_house_no: '',
            add_plot: '',
            add_contract_number: '',
            add_sales_price: '',
            add_deposit: '',
            add_balance: '',
            add_payment_type: '',
            val_payment_type: 'waiting',
            active: 1,
            period: []
        });
        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    closeModelPeriodUpdate() {
        this.setState({
            updatePeriodIsOpen: false,
            EditLineIsOpen: false
        });
        this.openEditAgain(this.state.add_id);
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    submitAdd() {

        if (!this.state.val_plot) {
            alert('ไม่พบข้อมูลแปลง');
            return;
        }

        if (!this.state.add_contract_number) {
            alert('ไม่พบข้อมูลเลขที่สัญญา');
            return;
        }

        if (!this.state.add_sales_price) {
            alert('ไม่พบข้อมูลราคาขาย');
            return;
        }

        if (!this.state.add_deposit) {
            alert('ไม่พบข้อมูลเงินจอง');
            return;
        }

        if (!this.state.add_balance) {
            alert('ไม่พบข้อมูลเงินสัญญา');
            return;
        }

        if (!this.state.period) {
            alert('ไม่พบข้อมูลงวด');
            return;
        }

        if (!this.state.add_transfer_date) {
            alert('ไม่พบข้อมูลวันโอนกรรมสิทธ์');
            return;
        }

        const formData = new FormData();
        formData.append('project_home_id', this.state.val_project);
        formData.append('contract_number', this.state.add_contract_number);
        formData.append('payment_type', this.state.val_payment_type);
        formData.append('sale_price', this.state.add_sales_price);
        formData.append('payment_down', this.state.add_paymentdown);
        formData.append('payment_down_total', this.state.add_paymentdowntotal);
        formData.append('transfer_price', this.state.add_transfer_price);
        formData.append('transfer_date', this.state.add_transfer_date);
        formData.append('address', this.state.add_address == null || this.state.add_address == '' ? "" : this.state.add_address);
        formData.append('deposit', this.state.add_deposit);
        formData.append('balance', this.state.add_balance);
        formData.append('residence_id', this.state.val_plot);
        formData.append('active_status', this.state.active ? 1 : 0);
        formData.append('createby', this.state.create_by);
        formData.append('createby_id', this.state.create_by_id);
        formData.append('myImage', this.state.file);
        formData.append('period', this.state.period.length > 0 ? JSON.stringify(this.state.period) : "");
        formData.append('period_hp', this.state.period_hp.length > 0 ? JSON.stringify(this.state.period_hp) : "");

        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': this.state.jwt,
            },
            body: formData
        };

        fetch(config.url.API_URL + '/payment', requestOptions)
            .then(res => res.json())
            .then(data => {
                if (data.status == "Error") {
                    alert("โครงการและบ้านเลขที่นี้มีอยู่ในระบบแล้ว")
                    return
                } else {
                    this.setState({
                        updateIsOpen: true
                    });

                }
            });

        this.setState({ addIsOpen: false });
    }

    fileHandler = (event) => {
        var fileObj = event.target.files[0];
        
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            } else {
                if (resp.rows[0].length == 8) {
                    var FromApi = resp.rows.map((datas, i) => {
                        return { no: datas[0], payment_day: new Date(1899, 12, datas[3] - 1), payment_slip: "", amount: datas[4], status: helpers.getPaymentType(datas[5]), status_progress: helpers.getHPType(datas[6]), detail: datas[7], status_name: datas[5], status_hp_name: datas[6] }
                    });
                    FromApi.shift()

                    var FromApi2 = resp.rows.map((datas, i) => {
                        return { no: datas[0], payment_day: new Date(1899, 12, datas[3] - 1), payment_slip: "", amount: datas[4], status: helpers.getHPType(datas[6]), detail: datas[7], status_name: datas[6], img: "" }
                    });
                    FromApi2.shift()
                    console.log(JSON.stringify(FromApi));
                    console.log(JSON.stringify(FromApi2));
                    this.setState({
                        period_check: [].concat(FromApi),
                        period: [].concat(FromApi),
                        period_hp: [].concat(FromApi2)
                    });
                } else {
                    alert("ไฟล์ไม่ตรงกับรูปแบบ กรุณาเลือกไฟล์ใหม่")
                    this.setState({
                        period_check: [],
                        period: [],
                        period_hp: []
                    });
                }
            }
        });

    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    closeImg() {
        this.setState({ ImgIsOpen: false });
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            add_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitDelete(e) {
        const requestOptions = {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                updateby: this.state.create_by,
                updateby_id: this.state.create_by_id
            }),
        };

        fetch(config.url.API_URL + '/payment/' + this.state.add_id, requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    updateIsOpen: true,
                    add_id: ''
                });
            });

        this.setState({ deleteIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_project: "",
            src_house_no: "",
            src_plot: "",
            src_contract_number: "",
            src_payment_type: "",
            add_project_type: "",
            page: 0
        });
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false });
    }

    changeStartDate = date => {
        this.setState({
            add_transfer_date: date
        });
    }

    changeName(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    onTagsChange = (event, values) => {
        if (values != null) {
            this.setState({
                add_house_no: values
            }, () => {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                };

                fetch(config.url.API_URL + '/residences/?projecthomeid=' + this.state.val_project
                    + '&houseno=' + this.state.add_house_no
                    , requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        //alert(data.status);
                        var FromApi = data.data.map(datas => {
                            return { value: datas.id, display: (datas.plot ? datas.plot : "ไม่ระบุแปลง") }
                        });

                        this.setState({
                            plot: FromApi,
                            val_plot: FromApi[0].value
                        });

                    });
            });
        } else {
            this.setState({
                plot: [],
                add_house_no: []
            })
        }

    }

    fileHandler2 = fileList => {
        console.log("fileList", fileList);
        var fileObj = fileList;
        if (!fileObj) {
            this.setState({
                errorMessage: "No file uploaded!"
            });
            return false;
        }
        console.log("fileObj.type:", fileObj.type);
        if (
            !(
                fileObj.type === "application/vnd.ms-excel" ||
                fileObj.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            )
        ) {
            this.setState({
                errorMessage: "Unknown file format. Only Excel files are uploaded!"
            });
            return false;
        }
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            } else {
                var newRows = [];
                if (resp.rows[0].length == 19) {
                    resp.rows.slice(1).map((row, index) => {
                        if (row.length > 0 && row !== "undefined") {
                            newRows.push({
                                key: index,
                                project_name: row[1],
                                houseNo: row[2],
                                plot: row[3],
                                contract_number: row[4],
                                sale_price: row[5],
                                deposit: row[6],
                                balance: row[7],
                                payment_type: row[8],
                                payment_down: row[9],
                                payment_down_total: row[10],
                                transfer_date: moment(new Date(1899, 12, row[11] - 1)).format('DD/MM/YYYY'),
                                transfer_price: row[12],
                                num_no: row[13],
                                no: row[14],
                                payment_day: moment(new Date(1899, 12, row[15] - 1)).format('DD/MM/YYYY'),
                                amount: row[16],
                                status: row[17],
                                detail: row[18]
                            });
                        }
                    }, {});
                } else {
                    alert("ไฟล์ไม่ตรงกับรูปแบบ กรุณาเลือกไฟล์ใหม่")
                    this.setState({
                        rows: [],
                        period_check: []
                    });
                }
                if (newRows.length === 0) {
                    this.setState({
                        errorMessage: "No data found in file!"
                    });
                    return false;
                } else {
                    this.setState({
                        rows: newRows,
                        errorMessage: null
                    });
                }
            }
        });
        return false;
    };

    submitVerify() {
        if (!this.state.rows) {
            alert("ไม่มีข้อมูลการ import")
            return
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                import_data: this.state.rows,
                createby: this.state.create_by,
                createby_id: this.state.create_by_id

            })
        };

        fetch(config.url.API_URL + '/verifyimport_payment', requestOptions)
            .then(res => res.json())
            .then(data => {
                var dataArr = data.data
                if (dataArr) {
                    if (data.dataverify) {
                        alert("โครงการ และบ้านเลขที่นี้ไม่ตรงกับที่มีอยู่ในระบบ กรุณาตรวจสอบ")
                        this.setState({
                            rows: dataArr,
                            errorMessage: null,
                            IsVerify: false
                        });
                    } else {
                        alert("ตรวจสอบเรียบร้อย")
                        this.setState({
                            rows: dataArr,
                            errorMessage: null,
                            IsVerify: true
                        });
                    }
                }
            });

    }

    checkFile(file) {
        var errorMessage = "";
        if (!file || !file[0]) {
            return;
        }
        const isExcel =
            file[0].type === "application/vnd.ms-excel" ||
            file[0].type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        if (!isExcel) {
            errorMessage = "You can only upload Excel file!";
        }
        console.log("file", file[0].type);
        const isLt2M = file[0].size / 1024 / 1024 < 2;
        if (!isLt2M) {
            errorMessage = "File must be smaller than 2MB!";
        }
        console.log("errorMessage", errorMessage);
        return errorMessage;
    }

    changeProjectType(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        this.project_home(e.target.value)
    }

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Payment Amount List</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Payment Amount</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    <ExcelFile filename="payments" element={(this.state.user_permission[229].permission == 1 &&
                                        <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.dataimport} name="payments">
                                            <ExcelColumn label="ลำดับ" value="num" />
                                            <ExcelColumn label="โครงการ" value="project_name" />
                                            <ExcelColumn label="บ้านเลขที่" value="house_no" />
                                            <ExcelColumn label="แปลง" value="plot" />
                                            <ExcelColumn label="เลขที่สัญญา" value={(col) => col.contact_no} />
                                            <ExcelColumn label="ราคาขาย" value="sale_price" />
                                            <ExcelColumn label="เงินจอง" value="deposit" />
                                            <ExcelColumn label="เงินสัญญา" value={(col) => col.balance} />
                                            <ExcelColumn label="ประเภทบ้าน" value={(col) => helpers.paymentType(col.payment_type)} />
                                            <ExcelColumn label="เงินดาวน์" value={(col) => col.payment_down} />
                                            <ExcelColumn label="เงินดาวน์ทั้งหมด" value={(col) => col.payment_down_total} />
                                            <ExcelColumn label="วันที่โอนกรรมสิทธิ์" value={(col) => col.transfer_date} />
                                            <ExcelColumn label="จำนวนเงินวันที่โอนกรรมสิทธิ์" value={(col) => col.transfer_price} />
                                            <ExcelColumn label="งวดที่" value={(col) => col.period_no} />
                                            <ExcelColumn label="วันที่ต้องชำระ" value={(col) => col.period_payment_day} />
                                            <ExcelColumn label="จำนวนเงิน" value={(col) => col.period_amount} />
                                            <ExcelColumn label="สถานะ" value={(col) => helpers.getPaymentTypeTh(col.period_status)} />
                                            <ExcelColumn label="รายละเอียด" value={(col) => col.period_detail} />
                                            {/* <ExcelColumn label="ที่อยู่" value={(col) => col.address} /> */}
                                            <ExcelColumn label="ที่อยู่จัดส่งเอกสาร" value={(col) => col.address} />
                                            <ExcelColumn label="อัพเดทล่าสุด" value={(col) => col.updateby} />
                                            <ExcelColumn label="อัพเดทล่าสุด(วันที่)" value={(col) => col.updated} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                    {(this.state.user_permission[230].permission == 1 &&
                                        // <div className="btn-add text-center" width={"500px"}><a href={'https://admin.nvdsmarthome.com/downloadFile/Payment_Import_template.xlsx'} style={{ color: 'black' }} >ตัวอย่างหลายรายการ</a></div>
                                        <div className="btn-add text-center" width={"500px"}><a href={`${config.url.API_URL}/downloadFile/Payment_Import_template.xlsx`} style={{ color: 'black' }} >ตัวอย่างหลายรายการ</a></div>
                                    )}
                                    {(this.state.user_permission[69].permission == 1 &&
                                        <div className="btn-add text-center" ><a href={`${config.url.API_URL}/downloadFile/template_payment2.xlsx`} style={{ color: 'black' }}>ตัวอย่างรายการเดียว</a></div>
                                    )}
                                    {(this.state.user_permission[66].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )}
                                    {(this.state.user_permission[228].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openImport}>Import หลายรายการ</div>
                                    )}
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                    {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                        !this.state.spinner && <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>โครงการ</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>บ้านเลขที่</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>แปลง</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ชื่อ-สกุล</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>เบอร์ติดต่อ</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ประเภทบ้าน</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ที่อยู่</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ที่อยู่จัดส่งเอกสาร</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                        <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                                return (
                                                                    <StyledTableRow key={`1${i}`}>
                                                                        <StyledTableCell>{i + 1}</StyledTableCell>
                                                                        <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                        <StyledTableCell>{data.house_no}</StyledTableCell>
                                                                        <StyledTableCell>{data.plot}</StyledTableCell>
                                                                        <StyledTableCell>{data.customer_name}</StyledTableCell>
                                                                        <StyledTableCell>{data.customer_tell}</StyledTableCell>
                                                                        <StyledTableCell>{data.payment_type}</StyledTableCell>
                                                                        <StyledTableCell>{data.address}</StyledTableCell>
                                                                        <StyledTableCell>{data.add_address}</StyledTableCell>
                                                                        <StyledTableCell>{data.updateby}<br />{data.updateby != undefined ? data.updated : ""}</StyledTableCell>
                                                                        <StyledTableCell>
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                            {(this.state.user_permission[67].permission == 1 &&
                                                                                <button className="btn-action text-center" data-id={data.id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                            )}
                                                                            {(this.state.user_permission[68].permission == 1 &&
                                                                                <button className="btn-action text-center" data-id={data.id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                            )}
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>)
                                                            })
                                                    }

                                                    {emptyRows > 0 && (
                                                        <StyledTableRow>
                                                            <StyledTableCell colSpan={6} />
                                                        </StyledTableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                rowsPerPageOptions={[10, 25, 50]}
                                                component="div"
                                                count={this.state.pages.length}
                                                rowsPerPage={this.state.rowsPerPage}
                                                page={this.state.page}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </TableContainer>
                                    }
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ประเภทโครงการ :</div>
                                <div className="col-sm-6">
                                    <select className="form-control" name="add_project_type" onChange={this.changeProjectType}>
                                        {this.state.project_type_pages.map((data, i) => <option key={i} value={data.value} selected={this.state.add_project_type === data.value && "selected"}>{data.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการ :</div>
                                <div className="col-sm-6">
                                    <select className="form-control" id="src_project" name="src_project" style={{ height: 45 }} onChange={this.change}>
                                        {this.state.project_homes.map((datas, i) => <option key={i} value={datas.value}>{datas.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">บ้านเลขที่ :</div>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" id="src_house_no" name="src_house_no" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">แปลง :</div>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" id="src_plot" name="src_plot" onChange={this.change} />
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col-sm-3 text-right">เลขที่สัญญา :</div>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" id="src_contract_number" name="src_contract_number" onChange={this.change} />
                                </div>
                            </div> */}
                            {/* <div className="row mb-3">
                                <div className="col-sm-3 text-right" >ชื่อโครงการ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="src_project" onChange={this.change}>
                                        {this.state.project_home.map((data, i) => <option key={i} value={data.value} >{data.display}</option>)}
                                    </select>
                                </div>
                            </div> */}
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ประเภทบ้าน<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-6">
                                    <select className="form-control" id="src_payment_type" name="src_payment_type" style={{ height: 45 }} onChange={this.change}>
                                        <option value="">ระบุประเภทบ้าน</option>
                                        <option value="waiting">สั่งสร้าง</option>
                                        <option value="finish">สร้างเสร็จ</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            {/* <div className="row mb-3">
                                <div className="col-sm-2 text-right">โครงการ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-8">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" id="val_project" name="val_project" style={{ height: 45 }} onChange={this.change}>
                                            {this.state.project_home.map((datas) =>
                                                <option value={datas.value} selected={this.state.val_project === datas.value && "selected"}>{datas.display}</option>
                                            )}
                                        </select>) : (<div className="form-control">{this.state.add_project}</div>)}
                                </div>
                            </div> */}
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">โครงการ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-8">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" id="val_project" name="val_project" style={{ height: 45 }} onChange={this.change}>
                                            {this.state.project_home.map((datas) =>
                                                <option value={datas.value} selected={this.state.val_project === datas.value && "selected"}>{datas.display}</option>
                                            )}
                                        </select>) : (<div className="form-control">{this.state.add_project}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">บ้านเลขที่<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen == 'add' || this.state.methodOpen == 'edit' ?
                                        (<Autocomplete
                                            name="add_house_no"
                                            value={this.state.add_house_no}
                                            options={this.state.residences}
                                            autoHighlight
                                            //getOptionLabel={(option) => option.display}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                label=""
                                                variant="outlined"
                                                inputProps={{
                                                    ...params.inputProps,
                                                    style: { fontSize: 20, fontFamily: "db_heaventmed_cond" }
                                                }}
                                                size="small"
                                            />}
                                            onChange={this.onTagsChange} />)
                                        : (<div className="form-control">{this.state.add_house_no}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">แปลง<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen == 'add' || this.state.methodOpen == 'edit' ?
                                        (<select className="form-control" name="val_plot" onChange={this.change}>
                                            {this.state.plot.map((datas) => <option value={datas.value}
                                                selected={this.state.val_plot == datas.value && "selected"}>{datas.display}</option>)}
                                        </select>)
                                        : (<div className="form-control">{this.state.add_plot}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">เลขที่สัญญา<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_contract_number" name="add_contract_number" defaultValue={this.state.add_contract_number} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_contract_number}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">ราคาขาย<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_sales_price" name="add_sales_price" defaultValue={this.state.add_sales_price} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_sales_price}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">เงินจอง<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_deposit" name="add_deposit" defaultValue={this.state.add_deposit} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_deposit}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">เงินสัญญา<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_balance" name="add_balance" defaultValue={this.state.add_balance} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_balance}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ประเภทบ้าน<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {//สั่งสร้าง = waiting, สร้างเสร็จ = finish
                                        this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                            ((<select className="form-control" id="val_payment_type" name="val_payment_type" style={{ height: 45 }} onChange={this.change}>
                                                <option value="waiting" selected={this.state.val_payment_type === "waiting" && "selected"}>สั่งสร้าง</option>
                                                <option value="finish" selected={this.state.val_payment_type === "finish" && "selected"}>สร้างเสร็จ</option>
                                            </select>))
                                            : (<div className="form-control">{this.state.add_payment_type}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">ภาพช่องทางการชำระเงิน :</div>
                                <div className="col-sm-3">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="file" name="myImage" onChange={this.onChange} accept="image/png, image/jpeg" />)
                                        : (this.state.add_img != '' ? <img src={this.state.add_img} alt="pic" height="200" width="auto" /> : "")}
                                </div>
                            </div>
                            {(this.state.val_payment_type == "waiting" ? (<div className="row mb-3">
                                <div className="col-sm-2 text-right">เงินดาวน์(ทั้งหมด)<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_paymentdowntotal" name="add_paymentdowntotal" value={this.state.add_paymentdowntotal} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_paymentdowntotal}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">วันโอนกรรมสิทธ์<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.add_transfer_date} id="start_date" onChange={this.changeStartDate} name="transfer_date" className="form-control" dateFormat="dd/MM/yyyy" />)
                                        : (<div className="form-control">{this.state.add_transfer_date}</div>)}
                                </div>
                            </div>) : (<div className="row mb-3">
                                <div className="col-sm-2 text-right">เงินดาวน์<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_paymentdown" name="add_paymentdown" value={this.state.add_paymentdown} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_paymentdown}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">วันโอนกรรมสิทธ์<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.add_transfer_date} id="start_date" onChange={this.changeStartDate} name="transfer_date" className="form-control" dateFormat="dd/MM/yyyy" />)
                                        : (<div className="form-control">{this.state.add_transfer_date}</div>)}
                                </div>
                            </div>))}

                            {(this.state.val_payment_type == "waiting" ? "" : <div className="row mb-3">
                                <div className="col-sm-2 text-right">จำนวนเงินวันโอนกรรมสิทธิ์<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="number" className="form-control" id="add_transfer_price" name="add_transfer_price" defaultValue={this.state.add_transfer_price} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_transfer_price}</div>)}
                                </div>
                            </div>)}


                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ที่อยู่จัดส่งเอกสาร </div>
                                <div className="col-sm-8">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<TextareaAutosize className="form-control" name="add_address" aria-label="minimum height" rowsMin={2} defaultValue={this.state.add_address} onChange={this.change} />)
                                        : (<TextareaAutosize className="form-control" name="add_address" aria-label="minimum height" rowsMin={2} defaultValue={this.state.add_address} disabled />)}
                                </div>
                            </div>

                            {
                                this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                    (<div className="row mb-3">
                                        <div className="col-sm-2 text-right">{(this.state.val_payment_type == "waiting" ? "file งวด" : "Deflect")} :</div>
                                        <div className="col-sm-3">
                                            <input type="file" onChange={this.fileHandler.bind(this)} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                                        </div>
                                    </div>) : ""
                            }

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ใช้งาน :</div>
                                <div className="col-sm-3">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color="primary"
                                        /></p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-12" style={{ padding: "0px 40px" }}>
                                    <div className="col-sm-2">{(this.state.val_payment_type == "waiting" ? "งวดชำระ" : "Deflect")} :</div>
                                    <table id="myTable" className="table table-bordered">
                                        <thead className="table-base">
                                            <tr>
                                                <th scope="col" style={{ width: '5%' }}>งวด</th>
                                                <th scope="col" style={{ width: '10%' }}>วันชำระ</th>
                                                <th scope="col" style={{ width: '10%' }}>จำนวนเงิน</th>
                                                {(this.state.methodOpen === 'add') ?
                                                    (<th scope="col" style={{ width: 'auto' }}>สถานะ payment</th>)
                                                    : (<th scope="col" style={{ width: 'auto' }}>สถานะ</th>)}

                                                {(this.state.methodOpen === 'add') ?
                                                    (<th scope="col" style={{ width: 'auto' }}>สถานะ house progress</th>)
                                                    : ("")}
                                                <th scope="col" style={{ width: '10%' }}>รูปภาพ</th>
                                                <th scope="col">Detail</th>
                                                {(this.state.period_check == 0) ?
                                                    (<th scope="col" style={{ width: '10%' }}>ดำเนินการ</th>)
                                                    : ("")}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(this.state.period && this.state.period.map(datas => {
                                                return (<tr>
                                                    <th scope="row">{datas.no}</th>
                                                    <td>{moment(datas.payment_day).format('DD/MM/YYYY')}</td>
                                                    <td>{datas.amount.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                                    {
                                                        this.state.methodOpen === 'view' || this.state.methodOpen === 'edit' ?
                                                            (<td>{helpers.getPaymentTypeTh(datas.status)}</td>) : <td>{datas.status_name}</td>
                                                    }

                                                    {
                                                        this.state.methodOpen === 'view' || this.state.methodOpen === 'edit' ?
                                                            ("") : <td>{datas.status_hp_name}</td>
                                                    }

                                                    {(datas.payment_slip != '' && datas.payment_slip != null) ? <td style={{ textAlign: 'center' }}>
                                                        <a href="#" className="nav-link" >
                                                            <i className="far fa-image" data-id={datas.payment_slip} onClick={this.openImg}></i>
                                                        </a>
                                                    </td> : <td style={{ textAlign: 'center' }}>
                                                            <a href="#" className="nav-link" >
                                                                -
                                                        </a>
                                                        </td>}
                                                    <td>{datas.detail}</td>
                                                    {(this.state.period_check == 0) ?
                                                        (<td style={{ textAlign: 'center' }}>
                                                            <button type="button" className="btn btn-warning" data-id={datas._id} onClick={this.openEditLine}><i className="far fa-edit" style={{ color: '#FFFFFF' }}></i></button>
                                                        </td>)
                                                        : ("")}
                                                </tr>)
                                            }))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.EditLineIsOpen} onHide={this.closeEditLine} size="lg">
                    <ModalHeader>
                        <ModalTitle>{this.state.period_no}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">วันชำระ</div>
                                <div className="col-sm-3">
                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.add_payment_date} id="payment_date" onChange={this.changeStartDate} name="payment_date" className="form-control" dateFormat="dd/MM/yyyy" />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">จำนวนเงิน</div>
                                <div className="col-sm-3">
                                    <input type="text" className="form-control" id="add_amount" name="add_amount" defaultValue={this.state.add_amount} onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right" >รายละเอียด</div>
                                <div className="col-sm-8">
                                    <TextareaAutosize className="form-control" aria-label="" rowsMin={1} defaultValue={this.state.add_detail} name="add_detail" placeholder="" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right" >สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-3">
                                    <select className="form-control" id="add_period_status" name="add_period_status" style={{ height: 45 }} onChange={this.changeName}>
                                        <option value=" " selected={this.state.add_period_status === "" && "selected"}>สถานะ</option>
                                        <option value="waiting" selected={this.state.add_period_status === "process" && "selected"}>รอชำระ</option>
                                        <option value="verify" selected={this.state.add_period_status === "verify" && "selected"}>รอตรวจสอบ</option>
                                        <option value="paid" selected={this.state.add_period_status === "paid" && "selected"}>ชำระแล้ว</option>
                                        <option value="overdue" selected={this.state.add_period_status === "overdue" && "selected"}>ค้างชำระเงิน</option>
                                        <option value="license" selected={this.state.add_period_status === "license" && "selected"}>รอใบอนุญาต</option>
                                        <option value="checked" selected={this.state.add_period_status === "checked" && "selected"}>ตรวจสอบแล้ว</option>
                                    </select>
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col-sm-3 text-right">รูปภาพ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-9">
                                    <input type="file" onChange={this.uploadMultipleFiles} multiple />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-7 text-right"><span style={{ color: 'red', fontSize: '18px' }}>*หมายเหตุ : รองรับไฟล์ขนาดไม่เกิน 1 MB (1120*720px) เฉพาะไฟล์ JPG,PNG</span></div>
                            </div> */}
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.AddEditLine}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updatePeriodIsOpen} onHide={this.closeModelPeriodUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelPeriodUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.ImgIsOpen} onHide={this.closeImg} size="lg">
                    <ModalHeader>
                        <ModalTitle></ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-12 center">
                                    <img src={this.state.img} alt="pic" height={300} width="auto" style={{ alignSelf: 'center' }} />
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeImg}>ปิด</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.importIsOpen} onHide={this.closeImport} size="xl">
                    <ModalHeader>
                        <div className="row">
                            <div className="col-sm-12">
                                <Upload name="file" beforeUpload={this.fileHandler2} onRemove={() => this.setState({ rows: [] })} multiple={false} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" >
                                    <Button className="btn btn-primary"> Import Excel File </Button>
                                </Upload>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-12">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>โครงการ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>บ้านเลขที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>แปลง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เลขที่สัญญา</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ราคาขาย</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เงินจอง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เงินสัญญา</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ประเภทบ้าน</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เงินดาวน์</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เงินดาวน์ทั้งหมด</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>วันที่โอนกรรมสิทธิ์</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>จำนวนเงินวันโอนกรรมสิทธิ์</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>จำนวนงวด</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>งวดที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>วันที่ต้องชำระ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>จำนวนเงิน</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สถานะ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>รายละเอียด</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>หมายเหตุ</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.rows.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.houseNo}</StyledTableCell>
                                                                    <StyledTableCell>{data.plot}</StyledTableCell>
                                                                    <StyledTableCell>{data.contract_number}</StyledTableCell>
                                                                    <StyledTableCell>{data.sale_price}</StyledTableCell>
                                                                    <StyledTableCell>{data.deposit}</StyledTableCell>
                                                                    <StyledTableCell>{data.balance}</StyledTableCell>
                                                                    <StyledTableCell>{data.payment_type}</StyledTableCell>
                                                                    <StyledTableCell>{data.payment_down}</StyledTableCell>
                                                                    <StyledTableCell>{data.payment_down_total}</StyledTableCell>
                                                                    <StyledTableCell>{data.transfer_date}</StyledTableCell>
                                                                    <StyledTableCell>{data.transfer_price}</StyledTableCell>
                                                                    <StyledTableCell>{data.num_no}</StyledTableCell>
                                                                    <StyledTableCell>{data.no}</StyledTableCell>
                                                                    <StyledTableCell>{data.payment_day}</StyledTableCell>
                                                                    <StyledTableCell>{data.amount}</StyledTableCell>
                                                                    <StyledTableCell>{data.status}</StyledTableCell>
                                                                    <StyledTableCell>{data.detail}</StyledTableCell>
                                                                    <StyledTableCell>{data.comment}</StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.rows.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div className='row'>
                            <button className="btn btn-warning" onClick={this.submitVerify}>ตรวจสอบข้อมูล</button>
                        &nbsp;&nbsp;
                            <button className="btn btn-danger" onClick={this.closeImport}>ยกเลิก</button>
                        &nbsp;&nbsp;
                            <button className="btn btn-success" data-id={this.state.add_id} onClick={this.submitImport}>ตกลง</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}